var map = {
	"./Bass.png": 4799,
	"./Drums.png": 7110,
	"./Guitar.png": 4393,
	"./Keyboard.png": 1146,
	"./Vocals.png": 541,
	"./acoustic-guitar.png": 2674,
	"./electric-guitar.png": 493,
	"./maracas.png": 3896,
	"./trombone.png": 2644,
	"./violin-2.png": 7387,
	"./violin.png": 1833
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8461;